import React from 'react'

type Props = {
  fieldProps: any
  touched: any
  errors: any
  displayText: string
  id?: string
}

export const AncientInputCheckbox: React.FC<Props> = ({
  displayText,
  fieldProps,
  touched,
  errors,
  id,
}) => {
  return (
    <div className='form-check form-check-custom form-check-solid form-check-sm mt-5 mb-5'>
      <input
        className='form-check-input'
        type='checkbox'
        checked={fieldProps.value}
        id={id}
        {...fieldProps}
      />
      <label className='form-check-label' htmlFor={id}>
        {displayText}
      </label>
      {touched && errors && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>{errors}</div>
        </div>
      )}
    </div>
  )
}
